import { FETCH_EMPLOYEE_CATEGORY, REQUEST_EMPLOYEE_CATEGORY } from '../actions/Types';

const EmployeeCategory = (state={loading: false, data: []}, action) => {
    switch(action.type){
        case FETCH_EMPLOYEE_CATEGORY:
            const new_state = {loading: false, data: action.payload}
            return new_state
        case REQUEST_EMPLOYEE_CATEGORY:
            return {loading: true, data: []}
        default:
            return state
    }
}

export default EmployeeCategory